import styled from 'styled-components'
import Button from '@material-ui/core/Button'

export const Item = styled(Button)`
  color: #fff;
  margin: 0 10px;
  font-size: 13px;
`
